import { render } from "./KnowledgeCard.vue?vue&type=template&id=0abd8b2d&scoped=true"
import script from "./KnowledgeCard.vue?vue&type=script&lang=js"
export * from "./KnowledgeCard.vue?vue&type=script&lang=js"

import "./KnowledgeCard.vue?vue&type=style&index=0&id=0abd8b2d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abd8b2d"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
